<template>
  <main class="content">
    <!-- content -->
    <section class="intro-3">
      <div class="container">
        <div class="intro-3__wrapper">
          <h1 class="intro-3__title">{{service.name}}</h1>
          <p class="intro-3__text" v-if="service.cf[363]">{{service.cf[363]}}</p>
        </div>
      </div>
    </section>

    <section class="work" v-if="service.cf[364] || service.cf[365] || service.cf[366] || service.cf[367] || service.cf[368] || service.cf[369] || service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
      <div class='container'>
        <div class="work__wrapper">
          <div class="work__top top-work" v-if="service.cf[364] || service.cf[365] || service.cf[366]">
            <div class="top-work__text" v-if="service.cf[364] || service.cf[365]">
              <h2 class="top-work__title" v-if="service.cf[364]">{{service.cf[364]}}</h2>
              <slot v-if="service.cf[365]">
                <p class="top-work__subtitle" v-if="cf" v-for="(cf, i) in service.cf[365].split('\n')" :key="i">{{cf}}</p>
              </slot>

            </div>
            <div class="top-work__right" v-if="service.cf[366]">
              <iframe class="top-work__video" :src="service.cf[366]"></iframe>
            </div>
          </div>
          <div class="work__down down-work" v-if="service.cf[367] || service.cf[368] || service.cf[369] || service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
            <div class="down-work__text">
              <p class="down-work__subtext" v-if="service.cf[367]">{{service.cf[367]}}</p>
              <h3 class="down-work__title" v-if="service.cf[368]">{{service.cf[368]}}</h3>
              <span class="down-work__subtitle" v-if="service.cf[369]">{{service.cf[369]}}</span>
              <ul class="down-work__list" v-if="service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
                <li v-if="service.cf[370]"><span>1</span> {{service.cf[370]}}</li>
                <li v-if="service.cf[371]"><span>2</span> {{service.cf[371]}}</li>
                <li v-if="service.cf[372]"><span>3</span> {{service.cf[372]}}</li>
                <li v-if="service.cf[373]"><span>4</span> {{service.cf[373]}}</li>
                <li v-if="service.cf[374]"><span>5</span> {{service.cf[374]}}</li>
              </ul>
            </div>

            <div class="work__down-img"></div>

          </div>
        </div>
      </div>
    </section>

    <section class="cards">
      <div class='container'>
        <div class="cards__wrapper">
          <h2 class="cards__title">Не нужны дорогостоящие юристы</h2>
          <div class="cards__box box-cards">
            <div class="box-item">
              <h4 class="box-item__header" v-if="service.cf[375]">{{service.cf[375]}}</h4>
              <h4 class="box-item__header" v-else>Выиграю дело сам</h4>
              <div class="box-item__body">
                <ul class="box-item__list">
                  <slot v-if="service.cf[376]">
                    <li v-if="cf" v-for="(cf, i) in service.cf[376].split('\n')" :key="i">{{cf}}</li>
                  </slot>
                  <li v-else>10 комплектов документов, с шаблонами которых наши клиенты уже выигрывали дела</li>
                </ul>

                <p class="box-item__text" v-if="service.cf[377]">{{service.cf[377]}}</p>
                <p class="box-item__text" v-else>
                  Это самый популярный тариф. Вы не только получите
                  все образцы документов благодаря которым выиграете
                  дело, но и получите 1 час видеоконсультации с
                  юристом + конкретный разбор своего дела</p>
              </div>
              <div class="box-item__footer">
                <span class="box-item__price" v-if="service.cf[378]">{{service.cf[378]}}</span>
                <span class="box-item__price" v-else>299 руб</span>
                <div class="box-item__footer-wrapper">
                  <button class="box-item__btn"><span>Выбрать</span></button>
                </div>
              </div>
            </div>
            <div class="box-item">
              <h4 class="box-item__header" v-if="service.cf[379]">{{service.cf[379]}}</h4>
              <h4 class="box-item__header" v-else>Выиграю дело сам</h4>
              <div class="box-item__body">
                <ul class="box-item__list">
                  <slot v-if="service.cf[380]">
                    <li v-if="cf" v-for="(cf, i) in service.cf[380].split('\n')" :key="i">{{cf}}</li>
                  </slot>
                  <slot v-else>
                  <li>10 комплектов документов</li>
                  <li>Видеоразбор и урок по возврату ав в Вашей ситуации</li>
                  <li>Персональный разбор Вашего дела</li>
                  </slot>
                </ul>
                <p class="box-item__text" v-if="service.cf[381]">{{service.cf[381]}}</p>
                <p class="box-item__text" v-else>
                  Это самый популярный тариф. Вы не только получите
                  все образцы документов благодаря которым выиграете
                  дело, но и получите 1 час видеоконсультации с
                  юристом + конкретный разбор своего дела</p>
              </div>
              <div class="box-item__footer">
                <span class="box-item__price" v-if="service.cf[382]">{{service.cf[382]}}</span>
                <span class="box-item__price" v-else>299 руб</span>
                <div class="box-item__footer-wrapper">
                  <button class="box-item__btn"><span>Выбрать</span></button>
                </div>
              </div>
            </div>
            <div class="box-item">
              <h4 class="box-item__header" v-if="service.cf[383]">{{service.cf[383]}}</h4>
              <h4 class="box-item__header" v-else>Выиграю дело сам</h4>
              <div class="box-item__body">
                <ul class="box-item__list">
                  <slot v-if="service.cf[384]">
                    <li v-if="cf" v-for="(cf, i) in service.cf[384].split('\n')" :key="i">{{cf}}</li>
                  </slot>
                  <slot v-else>
                  <li>1 час видеоконсультации с юристом</li>
                  <li>Персональный разбор Вашего дела</li>
                  <li>Юрист подготовит и сделает всё сам</li>
                  <li>Что то четвертое</li>
                  </slot>
                </ul>
                <p class="box-item__text" v-if="service.cf[385]">{{service.cf[385]}}</p>
                <p class="box-item__text" v-else>
                  Это самый популярный тариф. Вы не только получите
                  все образцы документов благодаря которым выиграете
                  дело, но и получите 1 час видеоконсультации с
                  юристом + конкретный разбор своего дела</p>
              </div>
              <div class="box-item__footer">
                <span class="box-item__price" v-if="service.cf[386]">{{service.cf[386]}}</span>
                <span class="box-item__price" v-else>299 руб</span>
                <div class="box-item__footer-wrapper">
                  <button class="box-item__btn"><span>Выбрать</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="history" v-if="service.cf[387] || service.cf[388] || service.cf[389] || service.cf[390] || service.cf[391] || service.cf[392] || service.cf[401] || service.cf[402]">
      <div class='container'>
        <div class="history__wrapper">
          <h3 class="history__title">Истории выигранных дел</h3>
          <div class="history__item item-history">
            <div class="item-history__block" v-if="service.cf[387] || service.cf[388]">
              <h5 class="item-history__title" v-if="service.cf[387]">{{service.cf[387]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[388]">{{service.cf[388]}}</p>
            </div>
            <div class="item-history__block" v-if="service.cf[389] || service.cf[390]">
              <h5 class="item-history__title" v-if="service.cf[389]">{{service.cf[389]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[390]">{{service.cf[390]}}</p>
            </div>
            <div class="item-history__block" v-if="service.cf[391] || service.cf[392]">
              <h5 class="item-history__title" v-if="service.cf[391]">{{service.cf[391]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[392]">{{service.cf[392]}}</p>
            </div>
            <div class="item-history__block" v-if="showAll">
              <h5 class="item-history__title" v-if="service.cf[401]">{{service.cf[401]}}</h5>
              <p class="item-history__subtitle" v-if="service.cf[402]">{{service.cf[402]}}</p>
            </div>
            <div class="item-history__link-wrapper" v-if="!showAll && (service.cf[401] || service.cf[402])">
              <a  class="item-history__link" @click="showAll = true"><span>Читать ещё</span></a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="for-whom whom-for">
      <div class='container'>
        <div class="for-whom__wrapper">
          <h1 class="for-whom__title">Для кого</h1>
          <ul class="for-whom__list">
            <li v-if="service.cf[393]">{{service.cf[393]}}</li><li v-else>Для тех, кому суд еще не назначили</li>
            <li v-if="service.cf[394]">{{service.cf[394]}}</li><li v-else>Для тех, кому суд уже назначили и времени мало</li>
            <li v-if="service.cf[395]">{{service.cf[395]}}</li><li v-else>Для тех, у кого суд был проигран, права сданы</li>
            <li v-if="service.cf[396]">{{service.cf[396]}}</li><li v-else>Для тех, у кого суд был проигран, права не сданы</li>
            <li v-if="service.cf[397]">{{service.cf[397]}}</li>
          </ul>
          <div class="whom-for__btn-wrapper">
            <button class="whom-for__btn"><span>Буду действовать</span></button>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
  import axios from '@/router/http'
  export default {
    name: 'service',
    data () {
      return {
        service: {
          cf: {}
        },
        showAll: false
      }
    },
    methods: {
      initPage () {
        axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
          this.service = response.data
          if (!this.service.cf) this.service.cf = {}
        })
      }
    },
    mounted () {
      this.initPage()
    },
    watch: {
      $route (to, from) {
        this.initPage()
      },
      'selectService.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectService.show = 0
          }, 100)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service.vue